import fetch from '../../utils/fetch'

export function selectBussinessParkinglot(businessPhone) {
    return fetch({
        url: '/api/parkinfo/selectBussinessParkinglot?businessPhone=' + businessPhone,
        method: 'GET',
    })
}

export function selectBussinessCoupon(query) {
    return fetch({
        url: '/api/bussinessCoupon/selectBussinessCoupon',
        method: 'GET',
        params: query
    })
}

// 轮询
export function sendCoupon(data) {
    return fetch({
        url: '/api/bussinessCoupon/wxSelectUnuseCouponInfoByTaskId',
        method: 'get',
        params: data
    })
}
